import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';

import { initGA } from './analytics';

// Initialize Google Analytics
initGA();

const el = document.getElementById('root');
const root = ReactDOM.createRoot(el);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);